module.exports = __webpack_public_path__ + "static/img/modal_bgzh-tw.6c1fcee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/modal_bgzh-tw.png
// module id = 4RiE
// module chunks = 1